import React, { useState } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { Paper } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import { StyledTab, StyledTabs } from '../../../../components/StyledTabs';
import { a11yProps, TabPanel } from '../../../../components/TabPanel';
import NotApprovedBatches from './NotApprovedBatches';
import ApprovedBatches from './ApprovedBatches';
import ArchivedBatches from './ArchivedBatches';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            marginTop: theme.spacing(2),
        },
        textField: {
            minWidth: '30ch',
        },
        flexWrap: {
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'flex-start',
            },
        },
    })
);

export default function Batches() {
    const classes = useStyles();

    const [selectedTab, setSelectedTab] = useState(0);

    return (
        <Paper className={classes.paper}>
            <Box padding={1} paddingBottom={0}>
                <StyledTabs
                    value={selectedTab}
                    onChange={(_, newTab) => setSelectedTab(newTab)}
                    aria-label="disabled tabs example"
                >
                    <StyledTab label="Not Approved" {...a11yProps(0)} />
                    <StyledTab label="Approved" {...a11yProps(1)} />
                    <StyledTab label="Archived" {...a11yProps(2)} />
                </StyledTabs>
            </Box>
            <Divider />
            <TabPanel value={selectedTab} index={0}>
                <NotApprovedBatches />
            </TabPanel>
            <TabPanel value={selectedTab} index={1}>
                <ApprovedBatches />
            </TabPanel>
            <TabPanel value={selectedTab} index={2}>
                <ArchivedBatches />
            </TabPanel>
        </Paper>
    );
}
